<template>
<!-- MARKED FOR REMOVAL - ENTIRE DIRECTORY -->
  <b-modal
    ref="assistance-prov-modal-ref"
    id="assistance-prov-modal"
    hide-footer
    hide-header
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header modal-header-assistance">
        <h4 class="vtd-modal-title">Why Trailfinders</h4>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body">
        <section class="card text-small modal-body-main">
          <h4 class="mb-2">TRAILFINDERS UNRIVALLED CARE AND PROTECTION</h4>
          <p>
            We are available for you 24 hours a day, 7 days a week, 365 days a
            year, no matter what. When things go awry, perhaps strike action,
            adverse weather or a family emergency we are here to help, and
            renowned for being calm and considerate in a crisis. If we are
            forced to cancel your holiday due to world events, you will always
            have the option of a refund via the method you paid us.
          </p>
          <p>
            With Trailfinders you receive the very best financial safeguards in
            the industry, so let us take on the burden of responsibility.
          </p>
          <div class="text-center py-1 my-5">
            <img
              class="lazyload lazy"
              src="https://cdn.trailfinders.com/iowgcfylng_logo_tf-financial-guarantee.png?width=300&quality=10&blur=25"
              data-src="https://cdn.trailfinders.com/iowgcfylng_logo_tf-financial-guarantee.png?width=300"
              data-object-fit="cover"
              alt="Trailfinders Financial Guarantee"
              title="Trailfinders Financial Guarantee"
            />
          </div>
          <p>
            Trailfinders guarantees to make good any money paid to us in the
            event of the financial collapse of an airline, tour operator or any
            other provider.
          </p>
          <!-- Check user has come via IE and output IE related text -->
          <div v-if="getCountry === 'IE'">
            <div class="text-center py-2 my-5">
              <img
                class="lazyload lazy"
                src="https://cdn.trailfinders.com/p2i5t5bsg3_logo-itaa.png?width=300&quality=10&blur=25"
                data-src="https://cdn.trailfinders.com/p2i5t5bsg3_logo-itaa.png?width=300"
                data-object-fit="cover"
                alt="ITAA Protected"
                title="ITAA Protected"
              />
            </div>
            <p>
              If you book a tailormade holiday with Trailfinders, you'll benefit
              from the comprehensive protection offered by the Package Travel
              Regulations.
            </p>
          </div>
          <!-- Otherwise output UK related text -->
          <div v-if="getCountry !== 'IE'">
            <div class="text-center py-1 my-5">
              <img
                class="lazyload lazy"
                src="https://cdn.trailfinders.com/8bhwtggt7o_tf-trust-account-safe.png?width=300&quality=10&blur=25"
                data-src="https://cdn.trailfinders.com/8bhwtggt7o_tf-trust-account-safe.png?width=300"
                data-object-fit="cover"
                alt="Trailfinders Trust Account"
                title="Trailfinders Trust Account"
              />
            </div>
            <p>
              Your money is secured in a Trust Account from the moment you pay
              us. So in the very unlikely event of our insolvency, payments made
              in respect of future travel or for a gift card will be refunded in
              full. We keep your money safe and only use it to pay for
              <strong>your</strong> holiday, not to cover our day to day
              expenses. Furthermore Trailfinders has the strongest balance sheet
              in travel.
            </p>
          </div>
          <h4>Watch Our Covid-19 Response Video</h4>
        </section>
        <div class="video-container">
          <video
            width="100%"
            height="auto"
            poster="https://cdn.trailfinders.com/tdizy17cm4_covid19.jpg"
            controls
            preload="none"
          >
            <source
              src="https://vz-0c5f29ad-8d4.b-cdn.net/d28db2ed-ce3e-4f0a-a6c4-9986b89867bf/playlist.m3u8"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small
            >This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      site: "",
      domain: "",
      curr: "",
    };
  },
  methods: {
    async showModal() {
      this.$refs["assistance-prov-modal-ref"].show();
    },

    closeModal() {
      this.$refs["assistance-prov-modal-ref"].hide();
    },
  },
  computed: {
    ...mapGetters({
      userData: "auth/getUserData",
    }),
    ...mapGetters("booking", ["getCountry"]),
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
  mounted() {
    // Set site specifics depending on service
    if (this.userData && this.userData.service === "IE") {
      (this.site = "IE"), (this.domain = ".ie");
      this.curr = "€";
    } else {
      (this.site = "UK"), (this.domain = ".com"), (this.curr = "£");
    }
  },
};
</script>
<style lang="scss">
@import "./style.scss";

.message {
  margin-bottom: 20px;
}

.modal-guarantee-img {
  width: 200px;
}
</style>
